import { Col, Row } from "react-bootstrap";
import './LZCJIcon.css';

export default function LZCJIcon() {

    return (
        <Row id='lzcj'>
            <Col>
                <div className="cardStyle d-flex align-items-center justify-content-center">
                    <Row>
                        <Col className="d-flex align-items-center justify-content-center">
                            <span className="textStyle">蜡烛财局</span>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    )
}